import { SuitableSportFilter } from ".";
export class SportsMapper {
    constructor(sportDataMapper) {
        this.sportDataMapper = sportDataMapper;
    }
    map(sports) {
        if (!sports || sports.length === 0) {
            return [];
        }
        const mappedResult = sports.map(this.sportDataMapper);
        const filteredResult = mappedResult.filter(x => x.order >= 0 && x.numberOfEvents !== 0 && SuitableSportFilter(x));
        return filteredResult;
    }
    mapFromPushes(sports) {
        if (!sports || sports.length === 0) {
            return [];
        }
        const mappedResult = sports.map(this.sportDataMapper);
        const filteredResult = mappedResult.filter(x => x.numberOfEvents !== 0 && SuitableSportFilter(x));
        return filteredResult;
    }
}
//# sourceMappingURL=SportsMapper.js.map